export default {
  meta: {
    title: '自助选址-场地详情',
    url: '/place/list', // 埋点字段，上报归属的模块
    urlName: '自主选址' // 埋点字段，上报归属的
  }
};
